// Analítica · el grabador de Umami — el que llena los mapas de calor.
//
// Contrato: `PETICION_HEATMAPS_Y_PRIVACIDAD_WEB.md`, del servidor, 22.09.26.
// Va aparte de la medición: `m.js` cuenta páginas vistas y no sabe nada de
// clics ni de desplazamiento; eso lo recoge `recorder.js`, que es rrweb por
// dentro. Ajustes que pone el servidor y no nosotros: **15 % de las sesiones**,
// **5 minutos** como mucho, enmascarado moderado —lo que se teclea no se
// guarda— y mapas de calor encendidos.
//
// 🔴 **Detrás del consentimiento.** No es medición esencial: registra el
// recorrido de quien mira. Así que solo se carga con la analítica aceptada en
// el aviso de cookies, y no se carga sola al arrancar.
//
// 🔴 **Y no en las páginas donde se escriben datos.** Cuenta, verificar correo
// y restablecer contraseña quedan fuera: el enmascarado ya evita guardar el
// contenido de los campos, pero ahí no se graba ni el recorrido.
//
// ⚠️ **Por qué hacen falta las dos cosas, la puerta y el `rr-block`.** Este
// script **no se puede parar**: una vez cargado graba hasta que se agota su
// sesión, y no expone nada para detenerlo —comprobado leyéndolo el 22.09.26: no
// deja global propia, no mira `doNotTrack` ni `umami.disabled`—. En una
// aplicación de una sola página eso significa que quien entra por la portada y
// luego va a su cuenta seguiría grabado. Por eso, además de no arrancarlo en
// esas rutas, sus vistas llevan `rr-block`, que es lo que rrweb entiende para
// no capturar un bloque.

const URL_GRABADOR = "https://stats.astra.fm/recorder.js";
const ID_SITIO = "3fc509d6-c343-4689-b954-2fc3c7a44e2d";

/**
 * Rutas donde no se graba.
 *
 * Se comparan por prefijo: `/cuenta` cubre el alta, el acceso y toda el área
 * —envíos de Radar incluidos—, que es lo que pide el contrato.
 */
const FUERA = ["/cuenta", "/verificar-correo", "/restablecer-contrasena"];

export function esRutaSinGrabar(ruta) {
  const r = String(ruta || "");
  return FUERA.some((p) => r === p || r.startsWith(`${p}/`));
}

let puesto = false;

/**
 * Carga el grabador, si toca. Llamarlo cuantas veces haga falta: solo hace algo
 * la primera.
 *
 * ⚠️ **Respeta `umami.disabled`**, la marca de «este navegador no mide» que
 * pone `?no-medir=1`. El grabador no la mira por su cuenta, así que la miramos
 * aquí: sin esto, las pruebas del equipo entrarían en los mapas de calor.
 */
export function arrancaElGrabador(ruta) {
  if (puesto || typeof document === "undefined") return;
  if (esRutaSinGrabar(ruta)) return;

  try {
    if (localStorage.getItem("umami.disabled")) return;
  } catch (e) {
    // Sin almacenamiento no hay marca que leer, y no es motivo para no medir.
  }

  puesto = true;

  const script = document.createElement("script");
  script.defer = true;
  script.src = URL_GRABADOR;
  script.setAttribute("data-website-id", ID_SITIO);
  document.head.appendChild(script);
}
